import React, { useEffect, useState } from "react";
// import { ComboboxField } from "../formElements/ComboboxField";
// import { InputField } from "../formElements/InputField";
// import CommonItemLevelDatatableModal from "../Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatPriceValue } from "../../../../common/Validations";
import { toast } from "react-hot-toast";
import { InputField } from "../../../../Components/formElements/InputField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";


const CommLineItemTablePO = (props) => {
  const [quotationDocument, setQuotationDocument] = useState([]);

  const [getawardQuotationNr, setawardQuotationNr] = useState([]);

  const filteredData = quotationDocument.filter(
    (item) => item.quotationNr === getawardQuotationNr
  );

  const [rfxQuestions, setRfxQuestions] = useState([]);
  // const [getDropdownData, setDropdownData] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [getPageStatus, setPageStatus] = useState(true);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const lineItemColInfo = [
    {
      name: "Item Text Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Item Text",
      cell: (row) => <span>{row.prItemNr} </span>,
      width: "250px",
    },
  ];

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  // const dropdownOption = [
  //   {
  //     id: "approve",
  //     name: "Approve",
  //   },
  //   {
  //     id: "reject",
  //     name: "Reject",
  //   },
  // ];

  useEffect(() => {
    if (
      !isInitialized &&
      props?.data?.length > 0 &&
      props?.data[0]?.rfxQuestions?.length > 0
    ) {
      // console.log(">> COMM ITEM props >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", props);
      // setQuotationDocument(props?.data[0]?.items[0]?.quotationDocument);

      setQuotationDocument(props?.data[0]?.items[0]?.quotationDocument);
      setawardQuotationNr(props?.awardQuotationNr);

      setRfxQuestions(props?.data[0]?.items);
      // setPageStatus(props?.pageStatus);
      setPageStatus(true);

      setIsInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, isInitialized]);

  useEffect(() => {
    props?.sendDataToParent(rfxQuestions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxQuestions]);

  // Get Dropdown data select
  // useEffect(() => {
  //   // console.log(">> data ss", getDropdownData);
  //   // eslint-disable-next-line array-callback-return
  //   const updatedData = rfxQuestions?.map((rfxItem) => {
  //     const updatedQuotationDocument = rfxItem.quotationDocument?.map(
  //       (item) => {
  //         // Check if the quotationNr matches, then update the score
  //         return item.quotationNr === getDropdownData?.textCode
  //           ? {
  //               ...item,
  //               [getDropdownData?.textField]: getDropdownData?.name, // Update the score
  //             }
  //           : item; // Return unchanged if quotationNr doesn't match
  //       }
  //     );

  //     // Return the updated rfxItem with the updated quotationDocument
  //     return rfxItem.rfxItemNr === getDropdownData?.index
  //       ? {
  //           ...rfxItem,
  //           quotationDocument: updatedQuotationDocument,
  //         }
  //       : rfxItem;
  //   });

  //   setRfxQuestions(updatedData);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getDropdownData]);

  // Update Comments
  // eslint-disable-next-line no-unused-vars
  const handleCommentsInput = (quotationNr, rfxItemNr, value) => {
    // eslint-disable-next-line no-unused-vars
    const updatedData = rfxQuestions?.map((rfxItem) => {
      const updatedQuotationDocument = rfxItem.quotationDocument?.map(
        (item) => {
          // Check if the quotationNr matches, then update the score
          return item.quotationNr === quotationNr
            ? {
              ...item,
              comments: value, // Update the score
            }
            : item; // Return unchanged if quotationNr doesn't match
        }
      );

      // Return the updated rfxItem with the updated quotationDocument
      return rfxItem.rfxItemNr === rfxItemNr
        ? {
          ...rfxItem,
          quotationDocument: updatedQuotationDocument,
        }
        : rfxItem;
    });
  };

  // NEED TO WORK ON THIS ITEM TABLE -------------------------------------------------------------------------------

  // Update Award Qty
  // const handleAwardQtyInput = (
  //   purchaseQuantity,
  //   quotationNr,
  //   rfxItemNr,
  //   value,
  //   quotationUnitPrice
  // ) => {

  //   const updatedData = rfxQuestions?.map((rfxItem) => {
  //     if (rfxItem.rfxItemNr !== rfxItemNr) return rfxItem;

  //     let totalAwardQty = 0;

  //     const updatedQuotationDocument = rfxItem.quotationDocument?.map(
  //       (item) => {
  //         let updatedAwardQty = item.quotationNr === quotationNr ? Number(value) : Number(item?.awardQty || 0);
  //         totalAwardQty += updatedAwardQty;
  //         // Check if the quotationNr matches, then update the score
  //         return item.quotationNr === quotationNr
  //           ? {
  //             ...item,
  //             // awardTotalQtyRow:Number(Number(item?.awardTotalQtyRow || 0) + Number(value)),
  //             awardQty: updatedAwardQty,
  //             awardValue: updatedAwardQty ? updatedAwardQty * Number(quotationUnitPrice) : "",
  //           }
  //           : item; // Return unchanged if quotationNr doesn't match
  //       }
  //     );

  //     // Mark inputs as disabled if total exceeds or equals purchaseQuantity
  //     const finalQuotationDocument = updatedQuotationDocument?.map((item) => {
  //       return {
  //         ...item,
  //         isDisabled: totalAwardQty >= purchaseQuantity && item.quotationNr !== quotationNr
  //       };
  //     });

  //     // Return the updated rfxItem with the updated quotationDocument
  //     return rfxItem.rfxItemNr === rfxItemNr
  //       ? {
  //         ...rfxItem,
  //         // quotationDocument: updatedQuotationDocument,
  //         awardTotalQtyRow: totalAwardQty,
  //         quotationDocument: finalQuotationDocument,
  //       }
  //       : rfxItem;
  //   });

  //   // console.log(">> handleCommentsInput updatedData", updatedData);
  //   setRfxQuestions(updatedData);
  //   // addScoreToItem(rfxItemNr, value);
  // };

  const handleAwardQtyInput = (
    purchaseQuantity,
    quotationNr,
    rfxItemNr,
    value,
    quotationUnitPrice
  ) => {
    const inputQty = Number(value);
    if (isNaN(inputQty)) return;

    const targetItem = rfxQuestions.find(
      (rfxItem) => rfxItem.rfxItemNr === rfxItemNr
    );
    if (!targetItem) return;

    // Calculate total awarded quantity excluding the current one (to avoid double counting)
    let existingAwardQty = 0;

    targetItem.quotationDocument?.forEach((item) => {
      if (item.quotationNr !== quotationNr) {
        existingAwardQty += Number(item.awardQty || 0);
      }
    });

    const newTotalAwardQty = existingAwardQty + inputQty;

    // ❌ Show error if total exceeds the purchase quantity
    if (newTotalAwardQty > purchaseQuantity) {
      toast.error("Award quantity exceeds purchase quantity!");
      return;
    }

    // ✅ Proceed with update
    const updatedData = rfxQuestions?.map((rfxItem) => {
      if (rfxItem.rfxItemNr !== rfxItemNr) return rfxItem;

      let totalAwardQty = 0;

      const updatedQuotationDocument = rfxItem.quotationDocument?.map(
        (item) => {
          let updatedAwardQty =
            item.quotationNr === quotationNr
              ? inputQty
              : Number(item.awardQty || 0);
          totalAwardQty += updatedAwardQty;

          return item.quotationNr === quotationNr
            ? {
              ...item,
              awardQty: updatedAwardQty,
              awardValue: updatedAwardQty
                ? updatedAwardQty * Number(quotationUnitPrice)
                : "",
            }
            : item;
        }
      );

      const finalQuotationDocument = updatedQuotationDocument?.map((item) => ({
        ...item,
        isDisabled:
          totalAwardQty >= purchaseQuantity && item.quotationNr !== quotationNr,
      }));

      return {
        ...rfxItem,
        awardTotalQtyRow: totalAwardQty,
        quotationDocument: finalQuotationDocument,
      };
    });

    setRfxQuestions(updatedData);
  };

  const addScoreToItem = (rfxItemNr, value) => {
    setRfxQuestions((prevItems) =>
      prevItems.map((item) =>
        item.rfxItemNr === rfxItemNr
          ? {
            ...item,
            awardTotalQtyRow: Number(
              Number(item.awardTotalQtyRow || 0) + Number(value)
            ),
          }
          : item
      )
    );

    // setRfxQuestions((prevRows) =>
    //   prevRows.map((row) => {
    //     if (row.rfxItemNr === rfxItemNr) {
    //       const updatedRow = {
    //         ...row,
    //         [`name_${rfxItemNr}`]: parseFloat(value) || 0, // Ensure value is a number or 0 if invalid
    //       };
    //       updatedRow.awardTotalQtyRow = updatedRow.input1 + updatedRow.input2 + updatedRow.input3; // Recalculate total
    //       return updatedRow;
    //     }
    //     return row;
    //   })
    // );
  };

  return (
    // <div
    //   className={
    //     quotationDocument?.length > 4
    //       ? "generatedTable width-400"
    //       : "generatedTable width-200"
    //   }
    // >
    //   <table className="table table-bordered">
    //     <thead>
    //       <tr>
    //         <th className="tableHeader"></th>
    //         <th className="tableHeader"></th>
    //         <th className="tableHeader"></th>
    //         <th className="tableHeader"></th>
    //         <th className="tableHeader"></th>
    //         <th className="tableHeader"></th>
    //         <th className="tableHeader"></th>
    //         {quotationDocument?.map((supplier, index) => (
    //           <th className="tableHeader text-center" colSpan={6} key={index}>
    //             <span className="bg-table-status bg-table-new-status px-2">
    //               {supplier.organisationName} - {supplier.quotationNr}
    //             </span>
    //             <div className="mt-1">Version: {supplier.qtnVersion}</div>
    //           </th>
    //         ))}
    //       </tr>
    //       <tr>
    //         <th className="tableHeader _01">SL No</th>
    //         <th className="tableHeader _03">Purchase Document</th>
    //         <th className="tableHeader _03">Status</th>
    //         <th className="tableHeader _04">Material Code</th>
    //         <th className="tableHeader _04">Qty</th>
    //         <th className="tableHeader _04">Unit</th>
    //         <th className="tableHeader _04">Item Text</th>
    //         {quotationDocument?.map((supplier, index) => (
    //           <React.Fragment key={index + 1}>
    //             <th className="tableHeader _04">Tech Eval</th>
    //             <th className="tableHeader _05">Initial Price</th>
    //             <th className="tableHeader _05">Final Price</th>
    //             {/* <th className="tableHeader _05">Final Price (RFQ CURR)</th> */}
    //             <th className="tableHeader _05">Net Unit Price</th>
    //             <th className="tableHeader _05">Award Qty</th>
    //             <th className="tableHeader _05">Award Value</th>
    //           </React.Fragment>
    //         ))}
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {rfxQuestions?.map((question, index) => {
    //         // Extract all final prices (qtnitemValue)
    //         const finalPrices = question?.quotationDocument?.map((s) =>
    //           parseFloat(s?.qtnitemValue || 0)
    //         );
    //         const minFinalPrice = Math.min(...finalPrices);
    //         const maxFinalPrice = Math.max(...finalPrices);

    //         return (
    //           <tr key={index + 1}>
    //             {/* SL No */}
    //             <td className="_01">
    //               {question?.rfxItemNr || question?.local_id}
    //             </td>
    //             {/* Purchase Document */}
    //             <td>{question?.purchaseReqDocumentNr}</td>
    //             {/* Status */}
    //             <td className="text-center">
    //               {question?.prStatusItem === "PR Approved" ? (
    //                 <span
    //                   className="bg-table-status bg-table-success-status d-flex justify-content-center"
    //                   style={{ width: "100px" }}
    //                 >
    //                   {question?.prStatusItem}
    //                 </span>
    //               ) : (
    //                 "-"
    //               )}
    //             </td>
    //             {/* Material Code */}
    //             <td>
    //               <div
    //                 className="ellipsis"
    //                 style={{ width: "120px" }}
    //                 title={question?.materialDescription}
    //               >
    //                 <b>{question?.materialCode}</b> <br />
    //                 {question?.materialDescription}
    //               </div>
    //             </td>
    //             {/* Qty */}
    //             <td>{question?.purchaseQuantity}</td>
    //             {/* Unit */}
    //             <td>{question?.orderUnitOfMeasure}</td>
    //             {/* Item Text */}
    //             <td>
    //               <div style={{ width: "60px" }}>
    //                 <span
    //                   style={{ marginLeft: "12px" }}
    //                   onClick={() => lineItemShowModal(question?.itemTextData)}
    //                 >
    //                   <i className="bi bi-calendar2-week iconTable"></i>
    //                 </span>
    //                 <span className="suppliersIcon">
    //                   {question?.itemTextData?.length}
    //                 </span>
    //               </div>
    //             </td>

    //             {question?.quotationDocument?.map((supplier, supplierIndex) => {
    //               const finalPrice = parseFloat(supplier?.qtnitemValue || 0);
    //               const color =
    //                 finalPrice === minFinalPrice
    //                   ? "green"
    //                   : finalPrice === maxFinalPrice
    //                   ? "red"
    //                   : "black";

    //               return (
    //                 <React.Fragment key={supplierIndex}>
    //                   {/* Tech Eval */}
    //                   <td>
    //                     {supplier?.approveReject === "Approve" ? (
    //                       <span className="bg-table-status bg-table-success-status d-flex justify-content-center">
    //                         {supplier?.approveReject}
    //                       </span>
    //                     ) : supplier?.approveReject === "Reject" ? (
    //                       <span className="bg-table-status bg-table-danger-status d-flex justify-content-center">
    //                         {supplier?.approveReject}
    //                       </span>
    //                     ) : (
    //                       supplier?.approveReject || "-"
    //                     )}
    //                   </td>
    //                   {/* Initial Price */}
    //                   <td className="text-end">
    //                     {formatPriceValue(supplier?.quotationUnitPrice)}
    //                   </td>
    //                   {/* Final Price */}
    //                   <td className="text-end">
    //                     <span style={{ color: color, fontWeight: "bold" }}>
    //                       {formatPriceValue(supplier?.quotationUnitPrice)}
    //                     </span>
    //                   </td>
    //                   {/* Net Unit Price */}
    //                   <td className="text-end">
    //                     {formatPriceValue(supplier?.qtnitemValue)}
    //                   </td>
    //                   {/* Award Qty */}
    //                   <td>
    //                     <div style={{ width: "100px" }}>
    //                       <InputField
    //                         type="number"
    //                         className="inputBox"
    //                         label=""
    //                         name="awardQty"
    //                         placeholder=""
    //                         value={supplier?.awardQty}
    //                         onChange={(e) =>
    //                           handleAwardQtyInput(
    //                             question?.purchaseQuantity,
    //                             supplier?.quotationNr,
    //                             question?.rfxItemNr,
    //                             e.target.value,
    //                             supplier?.quotationUnitPrice
    //                           )
    //                         }
    //                         onBlur={(e) =>
    //                           addScoreToItem(
    //                             question?.rfxItemNr,
    //                             e.target.value
    //                           )
    //                         }
    //                         disabled={getPageStatus || supplier.isDisabled}
    //                       />
    //                     </div>
    //                   </td>
    //                   {/* Award Value */}
    //                   <td>{supplier?.awardValue}</td>
    //                 </React.Fragment>
    //               );
    //             })}
    //           </tr>
    //         );
    //       })}
    //     </tbody>
    //   </table>
    //   <CommonItemLevelDatatableModal
    //     show={itemLevelModalShow}
    //     onHide={() => itemLevelHideModal()}
    //     columns={getItemLevelColumns}
    //     data={getItemLevelData}
    //     title={getModalTitle}
    //   />
    // </div>
    <div className="generatedTable width-100">
      {filteredData?.map((supplier, vendorIndex) => (
        <div
          key={vendorIndex}
          className="vendor-block mb-4 border rounded p-3 bg-light"
        >
          <div className="tableHeader text-center" colSpan={6}>
            <span className="bg-table-status bg-table-new-status px-2">
              {supplier.organisationName} - {supplier.quotationNr}
            </span>
            <div className="mt-1">Version: {supplier.qtnVersion}</div>
          </div>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="tableHeader _01">SL No</th>
                <th className="tableHeader _02" style={{ width: "180px" , fontSize: "12px"}}>Purchase Document</th>
                <th className="tableHeader _03">Status</th>
                <th className="tableHeader _04">Material Code</th>
                <th className="tableHeader _05">Qty</th>
                <th className="tableHeader _06">Unit</th>
                <th className="tableHeader _07">Item Text</th>
                <th className="tableHeader _08">Tech Eval</th>
                <th className="tableHeader _09">Initial Price</th>
                <th className="tableHeader _010">Final Price</th>
                <th className="tableHeader _011">Net Unit Price</th>
                <th className="tableHeader _012">Award Qty</th>
                <th className="tableHeader _013">Award Value</th>
              </tr>
            </thead>
            <tbody>
              {/* {rfxQuestions?.map((question, index) => {
                const supplierData = question?.quotationDocument?.find(
                  (q) => q.quotationNr === supplier.quotationNr
                );

                if (!supplierData) return null;

                return (
                  <tr key={index}>
                    <td>{question?.rfxItemNr || question?.local_id}</td>
                    <td>{question?.purchaseReqDocumentNr}</td>
                    <td className="text-center">
                      {question?.prStatusItem === "PR Approved" ? (
                        <span
                          className="bg-table-status bg-table-success-status d-flex justify-content-center"
                          style={{ width: "100px" }}
                        >
                          {question?.prStatusItem}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      <div
                        className="ellipsis"
                        style={{ width: "120px" }}
                        title={question?.materialDescription}
                      >
                        <b>{question?.materialCode}</b> <br />
                        {question?.materialDescription}
                      </div>
                    </td>
                    <td>{question?.purchaseQuantity}</td>
                    <td>{question?.orderUnitOfMeasure}</td>
                    <td>
                      <div style={{ width: "60px" }}>
                        <span
                          style={{ marginLeft: "12px" }}
                          onClick={() => lineItemShowModal(question?.itemTextData)}
                        >
                          <i className="bi bi-calendar2-week iconTable"></i>
                        </span>
                        <span className="suppliersIcon">
                          {question?.itemTextData?.length}
                        </span>
                      </div>
                    </td>

                    <td>
                      {supplierData?.approveReject === "Approve" ? (
                        <span className="bg-table-status bg-table-success-status d-flex justify-content-center">
                          {supplierData?.approveReject}
                        </span>
                      ) : supplierData?.approveReject === "Reject" ? (
                        <span className="bg-table-status bg-table-danger-status d-flex justify-content-center">
                          {supplierData?.approveReject}
                        </span>
                      ) : (
                        supplierData?.approveReject || "-"
                      )}
                    </td>

                    <td className="text-end">
                      {formatPriceValue(supplierData?.quotationUnitPrice)}
                    </td>
                   

                    <td className="text-end">
                      <span style={{ fontWeight: "bold" }}>
                        {formatPriceValue(supplierData?.quotationUnitPrice)}
                      </span>
                    </td>

                    <td className="text-end">
                      {formatPriceValue(supplierData?.qtnitemValue)}
                    </td>

                    <td>
                      <div style={{ width: "100px" }}>
                        <InputField
                          type="number"
                          className="inputBox"
                          label=""
                          name="awardQty"
                          placeholder=""
                          value={supplierData?.awardQty}
                          onChange={(e) =>
                            handleAwardQtyInput(
                              question?.purchaseQuantity,
                              supplierData?.quotationNr,
                              question?.rfxItemNr,
                              e.target.value,
                              supplierData?.quotationUnitPrice
                            )
                          }
                          onBlur={(e) =>
                            addScoreToItem(question?.rfxItemNr, e.target.value)
                          }
                          disabled={getPageStatus }
                            //  disabled={getPageStatus || supplier.isDisabled}
                            // disabled={true}

                        />
                      </div>
                    </td>

                    <td>{supplierData?.awardValue}</td>
                  </tr>
                );
              })} */}

              {rfxQuestions?.map((question, index) => {
                const supplierData = question?.quotationDocument?.find(
                  (q) => q.quotationNr === supplier.quotationNr
                );

                if (!supplierData) return null;

                // Get all valid prices for this question
                const prices = question?.quotationDocument
                  ?.map((q) => q.quotationUnitPrice)
                  .filter((price) => price !== undefined && price !== null);

                const minPrice = Math.min(...prices);
                const maxPrice = Math.max(...prices);

                const getPriceColor = (price) => {
                  if (price === minPrice) return "green";
                  if (price === maxPrice) return "red";
                  return "inherit";
                };

                const unitPrice = Number(supplierData?.quotationUnitPrice);

                return (
                  <tr key={index}>
                    <td>{question?.rfxItemNr || question?.local_id}</td>
                    <td style={{ width: "100px" }}>{question?.purchaseReqDocumentNr}</td>

                    <td className="text-center">
                      {question?.prStatusItem === "PR Approved" ? (
                        <span
                          className="bg-table-status bg-table-success-status d-flex justify-content-center"
                          style={{ width: "100px" }}
                        >
                          {question?.prStatusItem}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      <div
                        className="ellipsis"
                        style={{ width: "120px" }}
                        title={question?.materialDescription}
                      >
                        <b>{question?.materialCode}</b> <br />
                        {question?.materialDescription}
                      </div>
                    </td>

                    <td>{question?.purchaseQuantity}</td>
                    <td>{question?.orderUnitOfMeasure}</td>

                    <td>
                      <div style={{ width: "60px" }}>
                        <span
                          style={{ marginLeft: "12px" }}
                          onClick={() =>
                            lineItemShowModal(question?.itemTextData)
                          }
                        >
                          <i className="bi bi-calendar2-week iconTable"></i>
                        </span>
                        <span className="suppliersIcon">
                          {question?.itemTextData?.length}
                        </span>
                      </div>
                    </td>

                    <td>
                      {supplierData?.approveReject === "Approve" ? (
                        <span className="bg-table-status bg-table-success-status d-flex justify-content-center">
                          {supplierData?.approveReject}
                        </span>
                      ) : supplierData?.approveReject === "Reject" ? (
                        <span className="bg-table-status bg-table-danger-status d-flex justify-content-center">
                          {supplierData?.approveReject}
                        </span>
                      ) : (
                        supplierData?.approveReject || "-"
                      )}
                    </td>

                    <td className="text-end">
                      {formatPriceValue(supplierData?.quotationUnitPrice)}
                    </td>

                    <td className="text-end">
                      <span
                        style={{
                          fontWeight: "bold",

                          color: getPriceColor(unitPrice),
                        }}
                      >
                        {formatPriceValue(supplierData?.quotationUnitPrice)}
                      </span>
                    </td>

                    <td className="text-end">
                      {formatPriceValue(supplierData?.qtnitemValue)}
                    </td>

                    <td>
                      <div style={{ width: "100px" }}>
                        <InputField
                          type="number"
                          className="inputBox"
                          label=""
                          name="awardQty"
                          placeholder=""
                          value={supplierData?.awardQty}
                          onChange={(e) =>
                            handleAwardQtyInput(
                              question?.purchaseQuantity,
                              supplierData?.quotationNr,
                              question?.rfxItemNr,
                              e.target.value,
                              supplierData?.quotationUnitPrice
                            )
                          }
                          onBlur={(e) =>
                            addScoreToItem(question?.rfxItemNr, e.target.value)
                          }
                          disabled={getPageStatus}
                        // disabled={getPageStatus || supplier.isDisabled}
                        />
                      </div>
                    </td>

                    <td>{supplierData?.awardValue}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}

      {/* Item Level Modal */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </div>
  );
};

export default CommLineItemTablePO;
